import {
    Injectable
} from '@angular/core';

import * as moment from 'moment-timezone';
import * as tzlookup from 'tz-lookup';
import * as SunCalc from 'suncalc';

import * as L from "leaflet";
import "leaflet";
/*
import "proj4";
import "proj4leaflet";
*/
import 'leaflet-routing-machine';

import {
    v4 as uuidv4
} from 'uuid';

import {
    SERVICE,
    TIME
} from './NeurConstants';

import {
    PLACE_CATEGORIES
} from './PlaceCategories';

import {
    ExportedClass as WeatherService
} from './WeatherService';

import {
    MARKER_TYPE
} from './PlaceService';

import {
    ExportedClass as PlaceService
} from './PlaceService';

import {
    ExportedClass as NeurBackendService
} from './NeurBackendService';

import {
    ExportedClass as UserService
} from './UserService';

import {
    ExportedClass as NeurService
} from './NeurService';


/*
  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()

class TripService {

    constructor(private weatherService: WeatherService, private placeService: PlaceService, private backendService: NeurBackendService, private neurService: NeurService, private userService:UserService) {

    }

    public future_trips = [];
    public past_trips = [];
//    public current_trips = [];

    public async createNeurTrip(uid: Number, language: string, selectedPlace: any, info_criteria: string[], search_criteria: any, selected_poi_list: any) {

        let data = await this.backendService.createNeurTrip(uid, language, selectedPlace, info_criteria, search_criteria, selected_poi_list);
        if (!data) return null;
        let time;
        let hour;
        let minute;
        let image;
        let dataobj = JSON.parse(JSON.stringify(data));
        dataobj.duration.start_date = moment(dataobj.duration.start_date, 'YYYY-MM-DD').clone();
        dataobj.duration.end_date = moment(dataobj.duration.end_date, 'YYYY-MM-DD').clone();

        dataobj.image_landscape = dataobj.img_src;
        dataobj.image_portrait = dataobj.img_src;

        let now = moment();
        let forcast_end = now.clone().add(this.weatherService.MAX_FORCAST_DAYS, 'd');
        let diff = dataobj.duration.start_date.diff(now.startOf('d'), 'd');
        let forcast_start_index = 0;
        let forcast_end_index = /*forcast_start_index + */ Math.min((dataobj.daylist.length - diff), (this.weatherService.MAX_FORCAST_DAYS - diff));

        for (let i = 0; i < dataobj.daylist.length; i++) {
            dataobj.daylist[i].date = moment(dataobj.daylist[i].date, 'YYYY-MM-DD').clone();
            let daydate = dataobj.daylist[i].date;

            for (let j = 0; j < dataobj.daylist[i].itemlist.length; j++) {

                dataobj.daylist[i].itemlist[j].id = uuidv4();

                /* convert item.start to moment */
                let time = dataobj.daylist[i].itemlist[j].start;
                let hour = Math.floor(time) - 7;
                let minute = (time - hour) * 60;
                /* connect all start and end time assuming they are perfectly lined up */
                if (j == 0) {
                    if (i == 0) dataobj.daylist[i].itemlist[j].start = dataobj.daylist[i].date.clone().add({
                        hour: hour,
                        minute: minute
                    });
                    else dataobj.daylist[i].itemlist[j].start = dataobj.daylist[i - 1].itemlist[dataobj.daylist[i - 1].itemlist.length - 1].end;
                } else {
                    dataobj.daylist[i].itemlist[j].start = dataobj.daylist[i].itemlist[j - 1].end;
                }
                /* convert item.end to moment */
                time = dataobj.daylist[i].itemlist[j].end;
                hour = Math.floor(time) - 7;
                minute = (time - hour) * 60;
                dataobj.daylist[i].itemlist[j].end = dataobj.daylist[i].date.clone().add({
                    hour: hour,
                    minute: minute
                });
                /* take care the image landscape and potrait view size */
                if (dataobj.daylist[i].itemlist[j].hasOwnProperty('place')) {
                    dataobj.daylist[i].itemlist[j].place = this.neurService.calibratePlaceImages(dataobj.daylist[i].itemlist[j].place);

                    if (!dataobj.daylist[i].itemlist[j].place.hasOwnProperty('duration')) {
                        // TBD: lookup rules 
                        dataobj.daylist[i].itemlist[j].place.duration = [0, 1440]; //in minutes    
                    } else { // convert to minutes, and TBD: overwrite with neur rules if min is bigger than data 
                        if (dataobj.daylist[i].itemlist[j].place.hasOwnProperty('_id')) {
                            dataobj.daylist[i].itemlist[j].place.duration[0] = Math.max(TIME.ACTIVITY_MINIMAL_TIME, dataobj.daylist[i].itemlist[j].place.duration[0]);
                            dataobj.daylist[i].itemlist[j].place.duration[1] = Math.min(1440, dataobj.daylist[i].itemlist[j].place.duration[1]);
                        }
                    }

                    dataobj.daylist[i].itemlist[j].place = this.placeService.makeMarkers(dataobj.daylist[i].itemlist[j].place);

                    /* convert na_time to moment */
                    if (dataobj.daylist[i].itemlist[j].place.hasOwnProperty('na_time')) {
                        for (let k = 0; k < dataobj.daylist[i].itemlist[j].place.na_time.length; k++) {
                            let naday = dataobj.daylist[i].itemlist[j].place.na_time[k].day;
                            let nastart = dataobj.daylist[i].itemlist[j].place.na_time[k].start;
                            let naend = dataobj.daylist[i].itemlist[j].place.na_time[k].end;
                            hour = Math.floor(nastart);
                            minute = (nastart - hour) * 60;
                            dataobj.daylist[i].itemlist[j].place.na_time[k].start = dataobj.duration.start_date.clone().add(naday - 1, 'd').set({
                                hour: hour,
                                minute: minute
                            });
                            hour = Math.floor(naend);
                            minute = (naend - hour) * 60;
                            dataobj.daylist[i].itemlist[j].place.na_time[k].end = dataobj.duration.start_date.clone().add(naday - 1, 'd').set({
                                hour: hour,
                                minute: minute
                            });
                        }
                    }
                }
            }

            this.updateDayWeatherInfo(dataobj.daylist[i], (i >= forcast_start_index && i < forcast_end_index));
        }
        this.udpateItinerarySummaries(dataobj.daylist);

        return dataobj;
    }

    public retreive() {
        let self = this;
        var trips = this.userService.user_info.past_trips;
        let deserializedTrips = [];
        let dTrip;
        if (trips && trips.length > 0) {
            trips.forEach((trip)=> {
                dTrip = self.deserializeMomentOfTripItem(trip);
                self.connectMoments(dTrip);
                deserializedTrips.push(dTrip);
            });
            this.past_trips = deserializedTrips;
        }
        trips = this.userService.user_info.future_trips;
        this.updateFutureTrips(trips);
    }

    private seralizeTrips(trips){
        let serializedTrips =[];
        let self = this;
        trips.forEach((trip)=> {
                serializedTrips.push(self.serializeMomentOfTripItem(trip));
        });
        return serializedTrips;
    }
    
    public async save(future:boolean) {
        if (future){
            this.userService.user_info.future_trips = this.seralizeTrips(this.future_trips);
        } 
        else {
            this.userService.user_info.past_trips = this.seralizeTrips(this.past_trips);
        }
        await this.userService.save_user_infobase();
    }

    public updateFutureTrips(trips ? ) {
        let self = this;
        let _recoverMoment = true;
        if (!trips) {
            trips = this.future_trips;
            _recoverMoment = false;
        }
        if (trips.length > 0) {
            let now = moment();
            let deserializedTrips = [];
            let dTrip;

              trips.forEach((trip,index) => {
                if (_recoverMoment) {
                    dTrip = self.deserializeMomentOfTripItem(trip);
                    self.connectMoments(dTrip);
                }
                else {
                    dTrip = trip;
                }
                if (dTrip.duration.end_date.isBefore(now)) {
                    self.past_trips.push(dTrip);
                } 
/*
                else if (dTrip.duration.start_date.isBefore(now)) {
                    self.current_trips.push(dTrip);
                }
*/
                else {
                    deserializedTrips.push(dTrip);
                }
            });
            this.future_trips = deserializedTrips;
        }

    }

    public addTrip(trip: any) {
        /* past trip not addable */
        if ((this.future_trips.length == 0) || this.future_trips[this.future_trips.length - 1].duration.start_date.isBefore(trip.duration.start_date)) {
            this.future_trips.push(trip);
        } else {
            let left = 0;
            let right = this.future_trips.length - 1;
            let insertIndex = this.future_trips.length;

            while (left <= right) {
                const mid = Math.floor((left + right) / 2);
                const midTrip = this.future_trips[mid];

                if (
                    midTrip.duration.start_date.isBefore(trip.duration.start_date) ||
                    (midTrip.duration.start_date.isSame(trip.duration.start_date) && midTrip.duration.end_date.isBefore(trip.duration.end_date))) {
                    left = mid + 1; // Search to the right
                } else {
                    right = mid - 1; // Search to the left
                    insertIndex = mid; // Update the insertion index
                }
            }

            // Insert the new_trip at the appropriate index
            this.future_trips.splice(insertIndex, 0, trip);
        }
    }

    private handleError(error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            errMsg = `${error.status} - ${error.statusText}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }

        if (error.status === 404) {
            console.log('Server not Found');
        }

        console.log(errMsg);

        //return Observable.throw(error);
    }

    private async updateDayWeatherInfo(daylist: any, forcast: boolean) {
        if (!daylist.weather) {
            daylist.weather = {};
        }

        let list = daylist.itemlist
            .filter(item => item.place && PlaceService.isPOI(item.place.category))
            .map(item => { //item.place) :
                return {
                    ...item.place,
                    start: item.start,
                    end: item.end
                };
            })

        if (list.length > 0) {
            let check_index = (list.length % 2 == 0) || (list.length == 1) ? Math.floor(list.length / 2) : Math.ceil(list.length / 2);
            if (!daylist.weather.sunrise) {
                //  sunrise 
                let sunrise_index = check_index;
                let timezone = tzlookup(list[sunrise_index].coordinates.latitude, list[sunrise_index].coordinates.longitude);

                let timezoneOffset = moment.tz(timezone).utcOffset()

                let sunrise_time = moment(SunCalc.getTimes(daylist.date, list[sunrise_index].coordinates.latitude, list[sunrise_index].coordinates.longitude, 0).sunrise);
                // make the sunrise time zoneless 
                daylist.weather.sunrise = sunrise_time.clone().subtract(sunrise_time.utcOffset() - timezoneOffset, 'm');
            }
            if (!daylist.weather.sunset) {
                // sunset
                let sunset_index = check_index;

                let timezone = tzlookup(list[sunset_index].coordinates.latitude, list[sunset_index].coordinates.longitude);
                let timezoneOffset = moment.tz(timezone).utcOffset();
                let sunset_time = moment(SunCalc.getTimes(daylist.date, list[sunset_index].coordinates.latitude, list[sunset_index].coordinates.longitude, 0).sunset);

                daylist.weather.sunset = sunset_time.clone().subtract(sunset_time.utcOffset() - timezoneOffset, 'm');
            }

            daylist.weather.utcOffset = moment.tz(tzlookup(list[check_index].coordinates.latitude, list[check_index].coordinates.longitude)).utcOffset();

            if (forcast) {
                // assumed perfect format
                if (!daylist.weather.temperature) {
                    daylist.weather.temperature = {};
                }

                let weatherInfo = < any > await this.weatherService.getWeatherInfo(list[check_index].coordinates.latitude, list[check_index].coordinates.longitude, daylist.date, 1);

                if (weatherInfo) {
                    daylist.weather.code = weatherInfo.daily.weathercode[0];
                    daylist.weather.temperature.apparent_max = weatherInfo.daily.apparent_temperature_max[0];
                    daylist.weather.temperature.apparent_min = weatherInfo.daily.apparent_temperature_min[0];
                    daylist.weather.temperature.actual_max = weatherInfo.daily.temperature_2m_max[0];
                    daylist.weather.temperature.actual_min = weatherInfo.daily.temperature_2m_min[0];
                    daylist.weather.unit = weatherInfo.daily_units.apparent_temperature_max;
                    //daylist.weather.sunrise = moment(weatherInfo.daily.sunrise[0]);
                    //daylist.weather.sunset = moment(weatherInfo.daily.sunset[0]);
                    daylist.weather.utcOffset = weatherInfo.utc_offset_seconds / 60;
                }
            }
        }

    }


    async updateWeatherInfo(plan: any) {
        let now = moment();
        let forcast_end = now.clone().add(this.weatherService.MAX_FORCAST_DAYS, 'd');

        let diff = plan.duration.start_date.diff(now.startOf('d'), 'd');
        let forcast_start_index = 0;
        //if (!plan.duration.end_date.isBefore(now) && (diff <= this.weatherService.MAX_FORCAST_DAYS)) {
        if (diff < 0) {
            forcast_start_index = -diff;
            diff = 0;
        }

        let forcast_end_index = /*forcast_start_index + */ Math.min((plan.daylist.length - diff), (this.weatherService.MAX_FORCAST_DAYS - diff));

        for (let k = 0; k < plan.daylist.length; k++) {

            this.updateDayWeatherInfo(plan.daylist[k], (k >= forcast_start_index && k < forcast_end_index));

        }

    }

    private udpateItinerarySummaries(daylist: any) {
        let self = this;
        daylist.forEach((day) => {
            self.updateDailyItinerarySummary(day);
        });

    }

    public updateDailyItinerarySummary(day) {

        let list = day.itemlist
            .filter(item => item.place && PlaceService.isPOI(item.place.category));
        day.itinerarySummary = '<ion-rid>\n';
        list.forEach((item, index) => {
            day.itinerarySummary = day.itinerarySummary + '<ion-row id = "itemIndex' + index + '"><ion-col class="ion-align-self-baseline" size="auto"><div class="TimeColumn" idTimeColumn=' + index + '>' + item.start.format("LT") +
                ': </div></ion-col><ion-col class="ion-align=self-baseline"><div class="PlaceColumn" idPlaceColumn=' + index + '>' + item.place.name[0] + '</div>\n</ion-row>\n';
        });
        day.itinerarySummary = day.itinerarySummary + '</ion-grid>\n';
    }

    private deserializeMomentOfTripItem(dataobj) {

        let trip = {};
        let self = this;
        for (const key in dataobj) {
            const value = dataobj[key];
            if (Array.isArray(value)) {
                trip[key] = value.map(item => {
                    if (moment(item, moment.ISO_8601).isValid()){
                        return moment(item);
                    } else if (typeof item === 'object' && item !== null) {
                            return self.deserializeMomentOfTripItem(item);
                    }
                    return item;
                });
            }
            else if (moment(value, moment.ISO_8601).isValid()) {
                trip[key] = moment(value);
            } else if (typeof value === 'object' && value !== null) {
                trip[key] = this.deserializeMomentOfTripItem(value);
            } else {
                trip[key] = value;
            }
        }
        return trip;
/*
        let trip = dataobj;
        trip.duration.start_date = moment(dataobj.duration.start_date);
        trip.duration.end_date = moment(dataobj.duration.end_date);
        for (let i = 0; i < dataobj.daylist.length; i++) {
            trip.daylist[i].date = moment(dataobj.daylist[i].date);

            for (let j = 0; j < dataobj.daylist[i].itemlist.length; j++) {

                trip.daylist[i].itemlist[j].start = moment(dataobj.daylist[i].itemlist[j].start);
                trip.daylist[i].itemlist[j].end = moment(dataobj.daylist[i].itemlist[j].end);
                trip.daylist[i].weather.sunrise = moment(dataobj.daylist[i].weather.sunrise);
                trip.daylist[i].weather.sunset = moment(dataobj.daylist[i].weather.sunset);
                //dataobj.daylist[i].itemlist[j].max_end = moment(dataobj.daylist[i].itemlist[j].max_end);

                //connect the start and end 
                if (i > 0) {
                    trip.daylist[i].itemlist[0].start = trip.daylist[i - 1].itemlist[trip.daylist[i - 1].itemlist.length - 1].end;
                }
                if (j > 0) {
                    trip.daylist[i].itemlist[j].start = trip.daylist[i].itemlist[j - 1].end;
                }

                if (trip.daylist[i].itemlist[j].hasOwnProperty('place')) {
                    if (trip.daylist[i].itemlist[j].place.hasOwnProperty('na_time')) {
                        for (let k = 0; k < dataobj.daylist[i].itemlist[j].place.na_time.length; k++) {
                            trip.daylist[i].itemlist[j].place.na_time[k].start = moment(dataobj.daylist[i].itemlist[j].place.na_time[k].start);
                            trip.daylist[i].itemlist[j].place.na_time[k].end = moment(dataobj.daylist[i].itemlist[j].place.na_time[k].end);
                        }
                    }
                }
            }
        }
        return trip;
 */
    }

    private connectMoments(trip){
        for (let i = 0; i < trip.daylist.length; i++) {
            for (let j = 0; j < trip.daylist[i].itemlist.length; j++) {
                //connect the start and end 
                if (i > 0) {
                    trip.daylist[i].itemlist[0].start = trip.daylist[i - 1].itemlist[trip.daylist[i - 1].itemlist.length - 1].end;
                }
                if (j > 0) {
                    trip.daylist[i].itemlist[j].start = trip.daylist[i].itemlist[j - 1].end;
                }
            }        
        }

    }
    
    private serializeMomentOfTripItem(dataobj) {
        let trip={};
        let self = this;
        for (const key in dataobj) {
            const value = dataobj[key];
            if (Array.isArray(value)) {
                trip[key] = value.map(item => {
                    if (moment.isMoment(item)) {
                        return item.format();
                    } else if (typeof item === 'object' && item !== null) {
                            return self.serializeMomentOfTripItem(item);
                    }
                    return item;
                });
            }
            else if (moment.isMoment(value)) {
                trip[key] = value.format();
            } else if (typeof value === 'object' && value !== null) {
                trip[key] = this.serializeMomentOfTripItem(value);
            } else {
                trip[key] = value;
            }
        }
        return trip;
    }

    public recoverMomentOfObject(data) {
        data = moment(data);
        return data;
    }

    public routePoints(coord1, coord2) {

        /*
                let routingControl = L.Routing.control({
                    waypoints: [
                        L.latLng(coord1.latitude, coord1.longitude), // Start point coordinates
                        L.latLng(coord2.latitude, coord2.longitude) // End point coordinates
                    ],
                    show: false
                });

                routingControl.on('routesfound', function(e) {
                    var routes = e.routes;
                    console.log("routes:" + JSON.stringify(routes))
                    if (routes.length > 0) {
                        var route = routes[0]; // Assuming there is only one route

                        var summary = route.summary;
                        var totalTime = summary.totalTime; // Total time in seconds
                        var transportMethod = summary.totalDistance; // Transportation method

                        console.log('Total time:', totalTime, 'seconds');
                        console.log('Transportation method:', transportMethod);
                    }
                })

                routingControl.route();
        */
        let dist = (Math.abs(coord1.latitude - coord2.latitude) + Math.abs(coord1.longitude - coord2.longitude)) * 110; //in km
        if (Math.abs(coord1.latitude) < 0.01 && Math.abs(coord1.longitude) < 0.01) {
            dist = 0;
        } else if (Math.abs(coord2.latitude) < 0.01 && Math.abs(coord2.longitude) < 0.01) {
            dist = 0;
        }
        let hour = 0.25;
        let cat = 0; //walk
        if (dist > 500) {
            //need to fly 
            hour = dist / 500.0 + 2; //1 hour to get to the airport and leave the airport
            cat = 80101;
        } else if (dist > 100) {
            //need to take train 
            hour = dist / 60.0 + 0.5; //half hour in the train station
            cat = 80201;
        } else if (dist > 1) {
            //need to drive 
            hour = dist / 10.0;
            cat = 80211;
        }
        hour = Math.ceil(hour * 4) / 4; //round time to the nearest quater
        let minutes = hour * 60;
        return {
            "category": cat,
            "time": minutes
        };
    }


}


/*
    Service class should be exported as ExportedClass
*/
export {
    TripService as ExportedClass
};